import { Fragment, ReactNode } from 'react';
import { classNames } from '../../utils';
import styles from './BulletSeparatedList.module.css';

interface BulletSeparatedListProps {
    className?: string;
    list: ReactNode[];
}

const BulletSeparatedList = ({
    className,
    list,
}: BulletSeparatedListProps) => {
    return (
        <div
            className={classNames(styles.bulletSeparatedList, className && className)}
        >
            {list.map((item, index) => (
                <Fragment key={index}>
                    <span>{item}</span>
                    {list.length > 1 && index < list.length - 1 &&
                        <span>•</span>
                    }
                </Fragment>
            ))}
        </div>
    );
};

export default BulletSeparatedList;
